import * as recipientsService from '@/services/marketing/recipients'
import * as customersService from '@/services/crm/customers'

// import router from '@/router'

const DEFAULT_QUERY = {
  pagination: {
    total: 100,
    current: 1,
    pageSize: 100,
    pageSizeOptions: ['50', '100', '500', '1000'],
    showQuickJumper: true,
    showSizeChanger: true,
  },
  filters: null,
  sorter: { field: 'created_at', order: 'descend' },
}

const DEFAULT_META = {
  total: 100,
}

const DEFAULT_DATA = {
  data: null,
  loading: false,
  query: Object.assign({}, DEFAULT_QUERY),
  meta: Object.assign({}, DEFAULT_META),
}

const DEFAULT_COMP = {
  visible: false,
  loading: false,
  processing: false,
}

/*********************
 * * STORE OBJECT
 *********************/

export default {
  namespaced: true,
  state: {
    customers: Object.assign({}, DEFAULT_DATA),
  },

  getters: {
    // Main data
    data: (state) => (key) => state[key].data,
    loading: (state) => (key) => state[key].loading,
    query: (state) => (key) => state[key].query,
    pagination: (state) => (key) => state[key].query.pagination,
    filters: (state) => (key) => state[key].query.filters,
    sorter: (state) => (key) => state[key].query.sorter,
    meta: (state) => (key) => state[key].meta,
  },

  mutations: {
    INIT: (state) => {
      state.customer = state.customers = state.projects = state.tasks = Object.assign({}, DEFAULT_DATA)
      for (const [key, data] of Object.entries(state.ui)) {
        state.ui[key] = Object.assign({}, DEFAULT_COMP)
      }
    },
    UPDATE: (state, { key, data }) => {
      if (state[key]) state[key].data = data
    },
    SET_LOADING: (state, { key, loading }) => {
      if (state[key]) state[key].loading = loading
    },
    START: (state, key) => {
      if (state[key]) state[key].loading = true
    },
    END: (state, key) => {
      if (state[key]) state[key].loading = false
    },
    SET_QUERY: (state, { key, query }) => {
      if (state[key]) state[key].query = query || Object.assign({}, DEFAULT_QUERY)
    },
    SET_PAGINATION: (state, { key, pagination }) => {
      if (state[key]) {
        state[key].query = state[key].query || Object.assign({}, DEFAULT_QUERY)
        state[key].query.pagination = pagination
      }
    },
    SET_FILTERS: (state, { key, filters }) => {
      if (state[key]) {
        state[key].query = state[key].query || Object.assign({}, DEFAULT_QUERY)
        state[key].query.filters = filters
      }
    },
    SET_SORTER: (state, { key, sorter }) => {
      if (state[key]) {
        state[key].query = state[key].query || Object.assign({}, DEFAULT_QUERY)
        state[key].query.sorter = sorter
      }
    },
    SET_META: (state, { key, meta }) => {
      if (meta) {
        if (meta.total) state[key].query.pagination.total = meta.total
        if (state[key]) state[key].meta = meta
      }
    },
  },
  actions: {
    // initialization
    init({ commit }) {
      commit('INIT')
    },

    // set pagination
    setPagination({ commit }, { key, pagination }) {
      if (pagination && pagination.current) commit('SET_PAGINATION', { key, pagination })
    },
    // set filters
    setFilters({ commit }, { key, filters }) {
      if (filters && Object.keys(filters).length) commit('SET_FILTERS', { key, filters })
    },
    // set sorter
    setSorter({ commit }, { key, sorter }) {
      if (sorter && sorter.field) commit('SET_SORTER', { key, sorter })
    },
    // set all query same time
    updateQuery({ dispatch }, { key, query: { pagination, filters, sorter } }) {
      dispatch('setPagination', { key, pagination })
      dispatch('setFilters', { key, filters })
      dispatch('setSorter', { key, sorter })
      dispatch('fetchAll', key)
    },

    /*********************
     *  CUSTOMERS
     *********************/

    // data handling
    async fetchAll({ dispatch }, key) {
      if (key === 'customers') return await dispatch('fetchCustomers')
      return null
    },

    async fetchCustomers({ commit, state }) {
      commit('START', 'customers')
      const { customers: data, meta } = await customersService.fetchCustomers(state.customers.query)
      if (data) commit('UPDATE', { key: 'customers', data })
      if (meta) commit('SET_META', { key: 'customers', meta })
      commit('END', 'customers')
      return data
    },

    // async fetchRecipientGroups({ commit, state }) {
    //   commit('START', 'customers')
    //   const { customers: data, meta } = await recipientsService.fetchRecipientGroups(state.customers.query)
    //   if (data) commit('UPDATE', { key: 'customers', data })
    //   if (meta) commit('SET_META', { key: 'customers', meta })
    //   commit('END', 'customers')
    //   return data
    // },

    // async updateRecipientsGroup({ commit }, group) {
    //   commit('START', 'customer')
    //   if (customer) {
    //     const data = await recipientsService.updateRecipientGroup(group)
    //     if (data) commit('UPDATE', { key: 'customer', data })
    //     commit('END', 'customer')
    //     return data
    //   }
    //   commit('END', 'customer')
    //   return null
    // },
  },
}
